import { createLogger } from '@telia-ace/edge-log';

const log = createLogger('utils/config');

const config = {};

export function setConfig(clientKey, cnf) {
  log.trace('setConfig', clientKey, cnf);
  config[clientKey] = cnf;
}

export function getConfig(clientKey) {
  log.trace('getConfig', clientKey, config);
  return config[clientKey];
}
